export default __webpack_public_path__ + "static/media/2.43049b34.jpg";